import BottomSheet from '@/components/ui/bottom-sheet/BottomSheet';
import { Icon } from '@monash/portal-react';
import c from './edit-carparks-bottom-sheet.module.scss';

export const EditCarparksBottomSheet = ({
  isOpen,
  onClose,
  selectedCarparks,
  assembledParkingLocations,
  onMoveUp,
  onMoveDown,
  onDelete,
  index,
}) => {
  const isFirst = index === 0;
  const isLast = index === selectedCarparks?.length - 1;
  const selectedCarpark = selectedCarparks[index];
  const enrichedCarpark = assembledParkingLocations?.find(
    (location) => location.id === selectedCarpark?.value
  );
  const carparkName = enrichedCarpark?.name || 'unselected carpark';

  return (
    <BottomSheet isOpen={isOpen} onClose={onClose}>
      <div className={c.editCarparksBottomSheet}>
        <button
          className={c.action}
          onClick={onMoveUp}
          aria-label={`Move ${carparkName} up`}
          disabled={isFirst}
          type="button"
        >
          <Icon.ArrowUp /> Move up
        </button>

        <button
          className={c.action}
          onClick={onMoveDown}
          aria-label={`Move ${carparkName} down`}
          disabled={isLast}
          type="button"
        >
          <Icon.ArrowDown /> Move down
        </button>

        <button
          className={c.action}
          onClick={onDelete}
          aria-label={`Delete ${carparkName}`}
          type="button"
        >
          <Icon.Trash /> Delete
        </button>
      </div>
    </BottomSheet>
  );
};
